export default "__VITE_ASSET__CkGOVvpp__";